<template>
    <footer class="ml-[32px] mb-[32px]">
            <p class="font-inter font-[400] text-[14px] text-[#667085]">
                © Esedere Oghenetega Kelvin @July, 2022
            </p>
        </footer>
</template>

<script>

export default {
    name: 'Footer',
    components : {},
}

</script>

